// src/auth/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { keycloak, hasRole } from './keycloak';

export default function PrivateRoute({ children, roles }) {
  const location = useLocation();

  if (!keycloak.authenticated) {
    // come back to where we were; the "/" route will decide where to go next
    keycloak.login({ redirectUri: window.location.origin + location.pathname + location.search });
    return null;
  }

  if (roles?.length) {
    const ok = roles.some(r => hasRole(r));
    if (!ok) return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return children;
}
